import { posthog } from "posthog-js";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

const usePosthogPageView = () => {
  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState(location.pathname);
  useEffect(() => {
    if (location.pathname !== previousLocation) {
      posthog.capture("$pageview");
      setPreviousLocation(location.pathname);
    }
  }, [location, previousLocation]);
};

export { usePosthogPageView };
